import { render, staticRenderFns } from "./BillInfoV2.vue?vue&type=template&id=1447fc8c"
import script from "./BillInfoV2.vue?vue&type=script&lang=js"
export * from "./BillInfoV2.vue?vue&type=script&lang=js"
import style0 from "./BillInfoV2.vue?vue&type=style&index=0&id=1447fc8c&prod&lang=scss"
import style1 from "./BillInfoV2.vue?vue&type=style&index=1&id=1447fc8c&prod&lang=scss"
import style2 from "./BillInfoV2.vue?vue&type=style&index=2&id=1447fc8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports